export type DatadogRum = {
  setUser: (user: { id: string }) => void
  clearUser: () => void
}

export function datadogRum (): DatadogRum | undefined {
  return (window as any).DD_RUM
}
